import edgeLineInit from "../components/_edge-line";
import "bootstrap/js/dist/collapse";
edgeLineInit();
